import ReactGA from 'react-ga';
import { rateCallTwo } from '../api';
import { getRequestContext, reportToSentry } from '../helpers/sentry';
import { applicationError, clearApplicationError, setDeclinationMessages, setQuoteIsLoading } from './quote';
import { bindableQuoteReceived, fatalError } from './application';
import { ENVIRONMENT_URL, ERRORS } from '../constants';
import { addSource } from '../helpers/addSource';
import extractDeclinations from '../helpers/extractDeclinations';

import {
  selectPartnerAgencyExternalId,
  selectAgentProducerExternalId,
  selectAgentAgencyExternalId,
} from '../selectors';
import { Dispatch } from 'redux';
import { selectIsAgentMDA } from '../selectors/agent';

const handleRateCallTwo = (data: Application = {}) => {
  return async (dispatch: Dispatch, getState: () => ReduxState) => {
    dispatch(setQuoteIsLoading(true));
    const { application } = getState();
    const isUserMDA = selectIsAgentMDA(getState());

    const sourceData = addSource({ isMDA: isUserMDA });

    const producerExternalId = selectAgentProducerExternalId(getState());
    const agencyExternalId = selectAgentAgencyExternalId(getState()) ?? selectPartnerAgencyExternalId(getState());
    const addProducerOrAgencyExternalId = isUserMDA ? { producerExternalId } : { agencyExternalId };

    const requestData = {
      ...application,
      ...data,
      ...sourceData,
      ...addProducerOrAgencyExternalId,
    };

    return rateCallTwo(requestData)
      .then((res) => {
        if (res.data?.underwritingInformation?.declinations?.length > 0) {
          // combine all declinations from each policy object into a single array
          const declinations = extractDeclinations(res.data.underwritingInformation.declinations);

          dispatch(setDeclinationMessages(declinations));
          dispatch(fatalError(ERRORS.CAT_1.DECLINATION_ERROR));
        }

        dispatch(setQuoteIsLoading(false));

        if (!res.data.isSuccess) {
          dispatch(applicationError(res.data.errors));
        } else {
          dispatch(bindableQuoteReceived(res.data.quote));
          dispatch(clearApplicationError());

          try {
            const { partner } = getState();

            if (partner?.partnerToken && window.location.hostname.toLowerCase() === ENVIRONMENT_URL.PRODUCTION) {
              ReactGA.initialize('UA-127203748-3');
              ReactGA.event({
                category: 'Partner Quote',
                action: partner.partnerToken,
                label: partner.name,
                nonInteraction: true,
              });
            }
          } catch (error) {
            reportToSentry(error as any);
          }
        }
      })
      .catch((error) => {
        dispatch(setQuoteIsLoading(false));
        dispatch(fatalError(error));
        reportToSentry(error, getRequestContext({ requestData }));
        return Promise.reject(error);
      });
  };
};

export default handleRateCallTwo;
